
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ocean-smart-meter-backup-switch/specs",
      function () {
        return require("private-next-pages/ocean-smart-meter-backup-switch/specs/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ocean-smart-meter-backup-switch/specs"])
      });
    }
  